import { render } from "./BottomBanner.vue?vue&type=template&id=48caa914&scoped=true"
import script from "./BottomBanner.vue?vue&type=script&lang=js"
export * from "./BottomBanner.vue?vue&type=script&lang=js"

import "./BottomBanner.vue?vue&type=style&index=0&id=48caa914&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48caa914"]])

export default __exports__